/* ==========================================================================
   hero-shelf.js — the products on the hero cycle on their own.

   The shelf is a scroll-snap track (a swipeable row on a phone, four across
   on a desktop) holding twelve products. Every few seconds it advances one
   card, and rewinds to the start after the last. A hand always wins: hover,
   touch, wheel or keyboard focus pauses it, and it resumes a while after the
   hand leaves. It runs only while the shelf is actually on screen, never in
   a hidden tab, and not at all for anyone who has asked for reduced motion.
   ========================================================================== */
(function () {
  'use strict';

  var INTERVAL_MS = 3800;      // between steps
  var HOLD_MS = 7000;          // after a touch, wheel or focus
  var RESUME_MS = 1800;        // after the pointer leaves on a desktop

  function boot() {
    var track = document.querySelector('[data-shelf]');
    if (!track || track.dataset.cycling) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var cards = track.children;
    if (cards.length < 5) return;
    track.dataset.cycling = '1';

    var paused = false;
    var holdTimer = null;
    var onScreen = true;

    function gap() {
      var cs = getComputedStyle(track);
      return parseFloat(cs.columnGap || cs.gap) || 0;
    }

    function step() {
      var w = cards[0].getBoundingClientRect().width + gap();
      var max = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= max - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: w, behavior: 'smooth' });
    }

    function tick() {
      if (paused || !onScreen || document.visibilityState !== 'visible') return;
      step();
    }

    function hold(ms) {
      paused = true;
      clearTimeout(holdTimer);
      holdTimer = setTimeout(function () { paused = false; }, ms);
    }

    // The hand: touch, wheel and focus hold it for a while; a hovering
    // pointer holds it until it leaves, then it resumes shortly after.
    ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach(function (ev) {
      track.addEventListener(ev, function () { hold(HOLD_MS); }, { passive: true });
    });
    track.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse') { paused = true; clearTimeout(holdTimer); }
    });
    track.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse') hold(RESUME_MS);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
      }, { threshold: 0.3 }).observe(track);
    }

    setInterval(tick, INTERVAL_MS);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
